window.EmailActivationForm = function (scope, userActivationService) {
    var self = this;
    var formName = "email-activation-form";
    self.name = formName;
    self.data = {};
    var _protected = BaseForm.call(self, formName, scope);

    self.load = function (data) {
        self.data = data || {};
    };

    self.save = function () {
        var defer = $q.defer();
        self.validator.validate(function (isValid) {
            if (isValid) {
                var data = {
                    code: self.data.code,
                    password: self.data.password
                };
                defer.resolve(userActivationService.updateUserSecondaryInfo(data));
            }
        });
        return defer.promise;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case "confirm-password":

                self.data.password = self.data.password || "";

                if (value != self.data.password) {
                    if (showError) {
                        self.validator.validation[name].errors[rule.name] = true;
                    }

                    return false;
                }
                break;

            case "password-email-match":
                if (value && (value === self.data.user_info.email)) {
                    if (showError) {
                        self.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;

            case "weak-password":
                if (value && !Utils.validatePassword(value).pass && Utils.validatePassword(value).strength === 'weak') {
                    if (showError) {
                        self.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;

            case "short-password":
                if (value && !Utils.validatePassword(value).pass && Utils.validatePassword(value).strength === 'short') {
                    if (showError) {
                        self.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;
        }
        return true;
    };
};
